import { Markdown } from 'common/markdown-components';
import styles from './styles.module.css';

const markdownContent = `
## Why Do You Need to Check the RTP of Casino Games?
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958562289-577287446-image.webp_resize_fullx400)

Knowing the RTP of a casino game is essential because it indicates the percentage of wagered money a game is likely to return to players over time. The higher the RTP, the better the odds are in your favor, though it doesn't guarantee wins. Checking the RTP allows you to choose games that offer better long-term potential. Without this knowledge, you may end up playing games that have lower payout rates, reducing your chances of making a profit. It's a crucial factor for any player who wants to play strategically.

## How to Check the RTP of Games Yourself?
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958587607-46501768-image.webp_resize_fullx400)

You can easily check the RTP of almost every casino game. We’ve written detailed instructions for each provider, so you can view the RTP of slots and table games without hassle. To find the RTP for any game, simply visit our game provider page and use the search feature to locate your game. You’ll find the RTP percentage listed along with other important details about the game.
`;

export const SlotsDescription = () => {
  return (
    <div className={styles.container}>
      <Markdown data={markdownContent} />
    </div>
  );
};
